import { createContext } from 'react';
import { CountriesContextType } from './CountriesContext.types';

export const CountriesContext = createContext<CountriesContextType | undefined>(undefined);
